/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest = {
  ledgerCanisterId: string;
  start?: number | undefined;
  end?: number | undefined;
  step?: number | undefined;
};

/** @internal */
export const SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest$inboundSchema:
  z.ZodType<
    SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    start: z.number().int().optional(),
    end: z.number().int().optional(),
    step: z.number().int().default(3600),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
    });
  });

/** @internal */
export type SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest$Outbound = {
  ledger_canister_id: string;
  start?: number | undefined;
  end?: number | undefined;
  step: number;
};

/** @internal */
export const SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest$outboundSchema:
  z.ZodType<
    SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest$Outbound,
    z.ZodTypeDef,
    SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    start: z.number().int().optional(),
    end: z.number().int().optional(),
    step: z.number().int().default(3600),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest$ {
  /** @deprecated use `SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest$inboundSchema;
  /** @deprecated use `SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest$outboundSchema;
  /** @deprecated use `SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest$Outbound` instead. */
  export type Outbound =
    SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest$Outbound;
}

export function seriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequestToJSON(
  seriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest:
    SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest,
): string {
  return JSON.stringify(
    SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest$outboundSchema
      .parse(seriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest),
  );
}

export function seriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest' from JSON`,
  );
}
